import _regeneratorRuntime from 'babel-runtime/regenerator';
import _extends from 'babel-runtime/helpers/extends';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import TableList from '@/components/TableList/index.vue';
import { fetchGrantRecords, grantActivate } from '@/api/grant/grant';
import { fetchAdvertiserList } from '@/api/advertiser/manage.ts';
import { fetchGmakerTemplateList } from '@/api/gmaker/template';
import _ from 'lodash';
import Pagination from '@/components/Pagination/index.vue';
import DoubleCheckDialog from '@/views/warrant-manage/authorize-dialog/double-check-dialog.vue';
import AuthorizeRecordsTable from '../mixin/authorize-records-table.js';
// import { GrantType } from '@/common/permission'
import ListTooltipCell from '../components/list-tooltip-cell.vue';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    currentAuthorizeInfo: {
      type: Object,
      required: true
    },
    cookList: {
      type: Function,
      required: true
    }
  },
  components: {
    TableList: TableList,
    Pagination: Pagination,
    DoubleCheckDialog: DoubleCheckDialog,
    ListTooltipCell: ListTooltipCell
  },
  mixins: [AuthorizeRecordsTable],
  data: function data() {
    return {
      query: {
        page: 1,
        page_size: 15,
        adv_id: '',
        order: '-created_time'
      },
      pagination: {
        total: 0
      },
      doubleCheckDialog: {
        visible: false
      },
      currentAuthItem: {},
      list: [],
      advertiserList: [],
      templateList: [],
      loading: false
    };
  },

  methods: {
    handleSortChange: function handleSortChange(sort) {
      if (sort.order === 'descending') {
        this.query.order = '-created_time';
      } else if (sort.order === 'ascending') {
        this.query.order = 'created_time';
      } else {
        this.query.order = '';
      }
      this.getList(this.query);
    },
    getList: function getList(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                _context.next = 4;
                return fetchGrantRecords(_extends({}, data, {
                  adv_ids: _this.currentAuthorizeInfo.adv_id || ''
                  // grant_types:
                  //   this.currentAuthorizeInfo.grant_type === GrantType.Trial
                  //     ? GrantType.Trial
                  //     : [GrantType.Internal, GrantType.Normal].join(','),
                }));

              case 4:
                res = _context.sent;

                _this.list = (_.get(res, 'data.data.list') ? _this.cookList(res) : []).map(function (item) {
                  return _extends({}, item, {
                    statusSwitch: item.status === 'active' ? 1 : 0 // 增加控制开关字段
                  });
                });
                _this.pagination.total = _.get(res, 'data.data.total') || 0;

                _this.loading = false;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);
                _this.loading = false;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 10]]);
      }))();
    },
    getAdvertiserList: function getAdvertiserList(params) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetchAdvertiserList(params);

              case 2:
                res = _context2.sent;

                _this2.advertiserList = (_.get(res, 'data.data.list') || []).map(function (item) {
                  return _extends({}, item, {
                    value: item.id,
                    label: item.name
                  });
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getTemplateList: function getTemplateList(params) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return fetchGmakerTemplateList(_extends({}, params, { is_active: 1 }));

              case 2:
                res = _context3.sent;

                _this3.templateList = (_.get(res, 'data.data.list') || []).map(function (item) {
                  return _extends({}, item, {
                    value: item.id,
                    label: item.name
                  });
                });

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    checkedSubmit: function checkedSubmit() {
      this.updateStatus(this.currentAuthItem);
    },
    updateStatus: function updateStatus(item) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return grantActivate({
                  id: item.id
                });

              case 3:
                res = _context4.sent;

                if (_.get(res, 'data.code') === 0) {
                  _this4.$message({
                    type: 'success',
                    message: '激活成功'
                  });
                }
                _this4.$emit('reload-list');
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](0);

                console.log(_context4.t0);

              case 11:

                _this4.getList(_this4.query);

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 8]]);
      }))();
    },
    handleSwitch: function handleSwitch(item) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.currentAuthItem = item;
                _this5.doubleCheckDialog.visible = true;

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.query.page_size = val;
      this.getList(this.query);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.query.page = val;
      this.getList(this.query);
    }
  },
  mounted: function mounted() {
    this.getAdvertiserList();
    this.getTemplateList();
  },

  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    },
    dialogAttrs: function dialogAttrs() {
      return {
        title: '广告主配置表'
      };
    },
    tableColumnConfig: function tableColumnConfig() {
      return this._tableColumnConfig.concat([{
        slot: 'action-cell'
      }]);
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      this.query.order = '-created_time';
    },
    visible: function visible(val) {
      if (val) {
        this.getList(this.query);
      }
    },
    'doubleCheckDialog.visible': function doubleCheckDialogVisible(val) {
      if (!val) {
        this.getList(this.query);
      }
    }
  }
};